import {
  usePermissions,
  useNotificationWindows,
  usePendingRequests,
  useCurrentWallet,
  useDevMode,
  useUserActivity,
} from '@plug-core/state'
import { syncStore } from './syncStores.web'

export const syncStores = () => {
  ;[
    usePermissions,
    useNotificationWindows,
    usePendingRequests,
    useCurrentWallet,
    useDevMode,
    useUserActivity,
  ].forEach(syncStore)
}